module.exports = __webpack_public_path__ + "static/img/ggfw.92ee5ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CCT005/ggfw.png
// module id = 3CGt
// module chunks = 1